import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/assets";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/wall";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      toast.success("You're officially Robbed. Welcome.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-center">
        <img src={ASSETS.shrugging} alt="$ROBBED" className="w-24 mx-auto animate-floaty" />
        <h1 className="headline text-cream text-3xl mt-3">JOIN THE ROBBED</h1>
        <p className="font-mono text-dim text-sm mt-2">The internet's most financially questionable support group.</p>
      </div>

      <form onSubmit={submit} className="comic-card p-6 mt-8 space-y-4">
        <input data-testid="reg-name" required placeholder="Display name"
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="w-full bg-ink border-3 border-black px-3 py-2.5 font-mono text-sm text-cream focus:outline-none focus:border-neon" />
        <input data-testid="reg-email" type="email" required placeholder="Email"
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full bg-ink border-3 border-black px-3 py-2.5 font-mono text-sm text-cream focus:outline-none focus:border-neon" />
        <input data-testid="reg-password" type="password" required placeholder="Password (min 6 chars)"
          value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="w-full bg-ink border-3 border-black px-3 py-2.5 font-mono text-sm text-cream focus:outline-none focus:border-neon" />
        <button data-testid="reg-submit" disabled={loading} className="btn-neon w-full disabled:opacity-50">
          {loading ? "..." : "Create Account"}
        </button>
      </form>

      <div className="flex items-center gap-3 my-5">
        <div className="flex-1 h-[3px] bg-charcoal" />
        <span className="font-mono text-xs text-dim uppercase">or</span>
        <div className="flex-1 h-[3px] bg-charcoal" />
      </div>
      <button onClick={googleLogin} className="btn-ghost w-full" data-testid="reg-google">Continue with Google</button>

      <p className="text-center font-mono text-sm text-dim mt-6">
        Already robbed? <Link to="/login" className="text-neon hover:underline" data-testid="link-login">Log in</Link>
      </p>
    </div>
  );
}
